import { createContext } from 'ui/lib/react-utils'
import type { AihubContextState } from './types'

export const [AihubProvider, useAihubContext] = createContext<AihubContextState>({
  name: 'AihubContext'
})
